<template>
    <hts-modal
        :show="props.showPopupAddSchedule"
        :size="70"
        @hide="handleClose">
        <template #custom>
            <div
                v-for="(item, index) in data"
                :key="index">
                <div class="grid grid-cols-4 gap-5 mt-5">
                    <hts-form-input
                        v-model="data[index].from"
                        :label="$t('labels.fromKm')"
                        :required="true"
                        :color="props.color"
                        type="number"
                        :disabled="true"
                        :name="`${index}from`"
                        :prop="`${index}from`" />
                    <hts-form-input
                        v-model="data[index].to"
                        :label="$t('labels.toKm')"
                        :required="true"
                        :color="props.color"
                        type="number"
                        :name="`${index}to`"
                        :prop="`${index}to`"
                        :disabled="props.disabled"
                        @change="handleChangeInput(data, index)"
                        @input="handleCheckShowAddButton(data[index])" />
                    <hts-form-input
                        v-model="data[index].value"
                        :label="$t('labels.vehicleModule.valueMaintenance')"
                        :required="true"
                        :color="props.color"
                        type="number"
                        :disabled="props.disabled"
                        :name="`${index}value`"
                        :prop="`${index}value`"
                        @change="handleChangeInputValue(data, index)"
                        @input="handleCheckShowAddButton(data[index])" />
                    <div
                        v-if="index > 0 && index === data.length - 1"
                        class="h-7 w-7 mt-6 cursor-pointer flex items-center justify-center"
                        @confirm="handleRemoveSchedule(index)">
                        <hi-x-mark-icon class="h-7 w-7 fill-error-700" />
                    </div>
                </div>
            </div>
            <div class="flex justify-center mt-2">
                <div
                    v-if="!props.disabled && checkShowAddButton"
                    class="h-7 w-7 mt-3 cursor-pointer border-2 border-orange-500 rounded-full flex items-center justify-center"
                    @confirm="handleAddSchedule">
                    <hi-plus-icon class="h-5 w-5 fill-orange-700" />
                </div>
            </div>
            <div
                v-if="!props.disabled"
                class="flex absolute bottom-6 right-6">
                <div>
                    <div class="flex justify-end gap-5">
                        <hts-form-button
                            icon-name="hi-check-icon"
                            icon-position="right"
                            color="primary"
                            @click="handleSubmit">
                            {{ $t('labels.save') }}
                        </hts-form-button>
                        <hts-form-button
                            icon-name="hi-x-mark-icon"
                            icon-position="right"
                            color="error"
                            @click="handleClose">
                            {{ $t('labels.cancel') }}
                        </hts-form-button>
                    </div>
                </div>
            </div>
        </template>
    </hts-modal>
</template>
<script setup lang="ts">
import form from './imports/form'

const props = defineProps({
  showPopupAddSchedule: {
    type: Boolean,
    default: false
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: Number,
    default: 0
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  },
  disabled: {
    type: Boolean,
    default: false
  },
  vehicleCategoryIsSelected: {
    type: Object,
    default: () => {}
  }
})
const emits = defineEmits(['addSchedule', 'close', 'add'])
const data = ref<Array<any>>([{ ...form.initMaintenance }])
const checkShowAddButton = ref(false)
watch(props, () => {
  if (props.vehicleCategoryIsSelected && props.vehicleCategoryIsSelected.maintenanceSchedule.length) {
    data.value = props.vehicleCategoryIsSelected.maintenanceSchedule
  }
})
const handleAddSchedule = () => {
  const lastItem = data.value[data.value.length - 1]
  data.value.push({
    from: lastItem.to,
    to: 0,
    value: 0
  })
}
const handleRemoveSchedule = (index: any) => {
  data.value.splice(index, 1)
}
const handleChangeInput = (data: any, index: any) => {
  if (index === data.length - 1) {
    return null
  }
  data[index + 1].from = data[index].to
}
const handleChangeInputValue = (data: any, index: any) => {
  if (index === data.length - 1) {
    return null
  }
  data[index + 1].from = data[index].to
}
const handleCheckShowAddButton = (data: any) => {
  if ((!data.to && !data.value) || !data.to || !data.value) {
    checkShowAddButton.value = false
    return false
  } else if (data.to && data.value) {
    checkShowAddButton.value = true
  }
}
const handleSubmit = () => {
  data.value = data.value.map((item: any) => {
    if (!item.to && item.value) {
      item.to = Infinity
    }
    return item
  })
  const checkInvalid = data.value.filter((item: any) => item.from >= item.to || (item.to !== Infinity && (item.to - item.from) % item.value !== 0))
  const checkEmpty = data.value.filter((item: any) => !item.to && !item.value)
  if (checkEmpty.length > 0) {
    return $toast().error($t('labels.isRequired'))
  }
  if (checkInvalid.length > 0) {
    return $toast().error($t('labels.invalidData'))
  }
  emits('addSchedule', data.value)
  emits('close')
}
const handleClose = () => {
  emits('close')
}
</script>
